import React, { useState } from 'react';
import { t, useLocalization } from '../../l10n/l10n';
import { Button, Dialog } from '@economic/taco';
import VismaConnectVerifyInformationDialog from '../VismaConnectVerifyInformationDialog';
import { Link, Navigate } from 'react-router-dom';
import iconVismaConnectJoin from './join-vc-icon.svg';
import { useCurrentAgreement, useCurrentUser } from '@economic/react-app';
import ExternalLink from '../../ExternalLink';

function JoinPopupCloseLink({ closeLinkText, onClick, shouldRender }) {
    if (!shouldRender) {
        return null;
    }

    return (
        <span className="absolute top-0 right-0 mt-6 mr-6">
            <a onClick={onClick} href="#" className="text-blue">
                {closeLinkText}
            </a>
        </span>
    );
}

function JoinPopupLogoutLink({ logoutLinkText, shouldRender }) {
    if (!shouldRender) {
        return null;
    }

    return (
        <div className="vismaconnect-popups vismaconnect-join-link w-full text-center">
            <Link to="/logout" className="text-blue">
                {logoutLinkText}
            </Link>
        </div>
    );
}

enum States {
    Join = 1,
    Verify = 2,
}

export default function VismaConnectJoinDialog() {
    const loadingTexts = useLocalization(textIds);
    const agreement = useCurrentAgreement();
    const user = useCurrentUser();
    const [show, setShow] = useState(true);
    const [state, setState] = useState(States.Join);

    if (loadingTexts || !show) {
        return null;
    }

    if (user.vismaConnect.joinPopupVariant < 1 || agreement.showGettingStarted) {
        return null;
    }

    var titleTextId =
        user.vismaConnect.joinPopupVariant === 4
            ? t(`SIGNUP_CONNECT_MODAL_TITLE_4`)
            : t(`SIGNUP_CONNECT_MODAL_TITLE_COUNTDOWN`, { DAYS_BEFORE_BLOCK: user.vismaConnect.joinPopupDaysUntilBlock });

    var contentTextId =
        user.vismaConnect.joinPopupVariant === 4
            ? t(`SIGNUP_CONNECT_MODAL_CONTENT_4`)
            : t(`SIGNUP_CONNECT_MODAL_CONTENT_COUNTDOWN`, { DAYS_BEFORE_BLOCK: user.vismaConnect.joinPopupDaysUntilBlock });

    var enforcePopup = false;

    if (user.vismaConnect.joinPopupVariant === 4) {
        enforcePopup = true;
    }

    function handlePopupClose() {
        setShow(false);
        if (enforcePopup) {
            return <Navigate to="/logout" />;
        }
    }

    if (state === States.Verify) {
        return (
            <VismaConnectVerifyInformationDialog
                enforcePopup={enforcePopup}
                displayNewsletter={!agreement.isDeveloper}
                isForInvite={false}
                firstName={user.firstName}
                lastName={user.lastName}
                email={user.email}
                onDone={() => setShow(false)}
            />
        );
    }

    return (
        <Dialog size="dialog" open={show} showCloseButton={false} closeOnEscape={!enforcePopup}>
            <Dialog.Content aria-label={t(titleTextId)}>
                <div className="flex flex-col relative h-auto p-8">
                    <JoinPopupCloseLink
                        closeLinkText={t`SIGNUP_CONNECT_MODAL_CANCEL`}
                        onClick={() => handlePopupClose()}
                        shouldRender={!enforcePopup}
                    />
                    <br />

                    <h1 className="font-bold my-4 mx-auto">{t(titleTextId)}</h1>

                    <img className="self-center block my-3 mx-auto h-auto w-1/3" src={iconVismaConnectJoin} alt="" />

                    <br />

                    <p>{t(contentTextId)}</p>

                    <Button
                        className="my-8 self-center"
                        appearance="primary"
                        type="button"
                        onClick={() => setState(States.Verify)}>
                        {t`SIGNUP_CONNECT_MODAL_CONFIRM`}
                    </Button>

                    <ExternalLink
                        href={
                            enforcePopup ? t`SIGNUP_CONNECT_MODAL_READ_MORE_URL_BLOCKED` : t`SIGNUP_CONNECT_MODAL_READ_MORE_URL`
                        }>{t`SIGNUP_CONNECT_MODAL_READ_MORE`}</ExternalLink>

                    <br />

                    <JoinPopupLogoutLink logoutLinkText={t`SIGNUP_CONNECT_MODAL_LOGOFF`} shouldRender={enforcePopup} />
                </div>
            </Dialog.Content>
        </Dialog>
    );
}

const textIds = [
    'SIGNUP_CONNECT_MODAL_TITLE_4',
    'SIGNUP_CONNECT_MODAL_TITLE_COUNTDOWN',
    'SIGNUP_CONNECT_MODAL_CONTENT_4',
    'SIGNUP_CONNECT_MODAL_CONTENT_COUNTDOWN',
    'SIGNUP_CONNECT_MODAL_CANCEL',
    'SIGNUP_CONNECT_MODAL_CONFIRM',
    'SIGNUP_CONNECT_MODAL_LOGOFF',
    'SIGNUP_CONNECT_MODAL_READ_MORE',
    'SIGNUP_CONNECT_MODAL_READ_MORE_URL',
    'SIGNUP_CONNECT_MODAL_READ_MORE_URL_BLOCKED',
];
